/** #1554 — stop fake "playing" when exclusive position never advances. */

import { diagnosticLog } from '../utils/diagnosticLogger';
import { setSuppressWallClockAdvance } from './positionReconcile';
import { useMaestroStore } from '../store/maestroStore';

export const EXCLUSIVE_POSITION_STALL_MS = 5000;

export async function handleExclusivePlaybackStartFailed(
  rendererId: string,
  reason: string,
  suppressWallClockAdvance?: boolean,
): Promise<void> {
  const store = useMaestroStore.getState();
  const activeId = store.activeConnectorRenderer?.id;
  if (!activeId || rendererId !== activeId) return;

  if (suppressWallClockAdvance !== false) {
    setSuppressWallClockAdvance(true, reason || 'exclusive-playback-start-failed');
  }

  store.setPlaybackState('stopped');
  store.setRendererHasStream(false);
  store.updateTime(0, store.duration || 0);
  store.setTransportPlaybackError(reason || 'Playback did not start on this output.');

  diagnosticLog('warn', 'playback', 'exclusive_playback_start_failed', {
    rendererId,
    reason,
    suppressWallClockAdvance: suppressWallClockAdvance !== false,
  });

  const { TransportCommand } = await import('./TransportCommand');
  await TransportCommand.stopExclusiveEngine().catch(() => {});
}
